(ns web3.components.nameplate-locator
  (:require [web3.env :as env]
            [web3.view :as v]
            [goog.string :as gstring]
            [web3.utils :as utils]
            [web3.i18n :as i]
            [cljs.core.async :refer [go chan put! close! <! >! timeout]]
            [web3.persistence.transit :as t]
            [web3.components.select :as select]
            [reagent.core :as r]
            [web3.icons.shapes :as shapes]
            [web3.tracking.components :as tc]
            [web3.routing.utils :as routing-u]
            [web3.view.hiccup :as hiccup]))


(def nameplate-base-url (env/config :nameplate-base-url))
(defonce nameplate-data (r/atom nil))
;; see centriq-web.nameplate for original implementation

(def load-nameplate-data!
  (memoize
   (fn []
     (let [assets-url (str nameplate-base-url "/nameplate/asset-tags")
           matp-url (str nameplate-base-url "/nameplate/matp")]
       (go
        (let [data (merge (<! (utils/fetch-c assets-url {:format :text
                                                         :parse t/read}))
                          (<! (utils/fetch-c matp-url {:format :text
                                                       :parse t/read})))]
          (reset! nameplate-data
                  {:by-id (utils/map-keys str data)
                   :by-parent (->> data
                                   (vals)
                                   (mapv #(assoc % "display-name" (last (get % "path"))))
                                   (sort-by #(get % "display-name"))
                                   (group-by #(str (get % "parent-id" "categories"))))})))))))

(defn image-link [url]
  (str nameplate-base-url "/api/v1/nameplate-help/" (gstring/urlEncode url)))

(defn youtube-url->id [url]
  (let [{:keys [segments query]} (routing-u/parse-path url)
        path-params (apply hash-map (apply concat (partition 2 1 segments)))]
    (or (get query :v)
        (get path-params "v")
        (get path-params "embed")
        (get path-params "vi")
        (when (= 2 (count segments))
          (second segments)))))

(comment
 (= "1"
    (youtube-url->id "/a/b/vi/1")
    (youtube-url->id "/a/b/v/1")
    (youtube-url->id "/a/b/embed/1")
    (youtube-url->id "/a/b/v/2?v=1")
    (youtube-url->id "/a/1"))
 (= nil
    (youtube-url->id "/a/1/b/c")))

(defn youtube-embed-url [url]
  (str "https://www.youtube.com/embed/" (youtube-url->id url)))

(defn content-view [{:strs [id description
                            image video]}]

  (if image
    [:div
     [:div.margin-v-2 description]
     [:img.width-100p.margin-v-2 {:src (image-link image)}]]
    [:div
     [:div.margin-v-2 description]
     [:iframe.width-100p.margin-v-2 {:src (youtube-embed-url video)}]]))

(defn item-option [{:strs [id display-name]}]
  [:option {:key id
            :value id}
   display-name])

(defn choose-option [label]
  [:option {:key "default"
            :class "opacity-50"
            :value ""}
   (i/get :forms/choose-item {:label label})])

(v/defview locator-contents
  {:component-will-mount #(load-nameplate-data!)
   :component-did-mount (fn [this]
                          (swap! (:state this) assoc :watch-tutorial? true)
                          (utils/focus-first-input! this))}
  []
  (let [{:keys [state]} (r/current-component)
        {:keys [by-id by-parent]} @nameplate-data
        {:keys [category-id
                manufacturer-id
                subcategory-id]} @state
        [category-id
         manufacturer-id
         subcategory-id] (map utils/some-str [category-id
                                              manufacturer-id
                                              subcategory-id])]
    [:div.flex-auto.flex.flex-column.pad-all-3.relative
     [:div.flex-auto
      [:div.text-size-18.weight-medium.margin-bottom-1 (i/get :nameplate-locator/title)]
      [select/select
       {:key "category"
        :label (i/get :i/category)
        :loading? (not by-id)
        :on-change #(swap! state assoc :category-id (.. % -target -value))
        :value category-id}
       (choose-option (i/get :i/category))
       (doall (map item-option (get by-parent "categories")))]

      (when-let [brands (and category-id
                             (seq (get by-parent category-id)))]
        ;; manufacturers
        [select/select
         {:key "Brand"
          :label (i/get :i/manufacturer)
          :on-change #(swap! state assoc :manufacturer-id (.. % -target -value))
          :value manufacturer-id}
         (choose-option (i/get :i/manufacturer))
         (doall (map item-option brands))
         (when (seq (get-in by-id category-id "items"))
           [:option {:key category-id
                     :value category-id
                     :label (i/get :i/other)}])])

      (when-let [subcategories (and category-id
                                    manufacturer-id
                                    (not= manufacturer-id category-id)
                                    (get by-parent manufacturer-id))]
        ;; subcategory
        [select/select
         {:key "Subcategory"
          :label (i/get :i/subcategory)
          :on-change #(swap! state assoc :subcategory-id (.. % -target -value))
          :value subcategory-id}
         (choose-option (i/get :i/subcategory))
         (doall (map item-option subcategories))
         (when (seq (get-in by-id [manufacturer-id "items"]))
           [:option {:key manufacturer-id
                     :label (i/get :i/other)}])])

      (into [:div]
            (some->> (or (get-in by-id [subcategory-id "items"])
                         (get-in by-id [manufacturer-id "items"]))
                     (seq)
                     (map content-view)))

      [:div.text-size-14.line-h-18.margin-top-4
       [:<>
        [:div.text-size-14.weight-medium.margin-v-2 "More help"]
        [:a.text-blue.cursor-pointer.block.margin-v-1
         {:on-click #(swap! state update :watch-tutorial? not)}
         "Watch the tutorial"
         (-> (if (:watch-tutorial? @state)
               shapes/chevron-up
               shapes/chevron-down)
             (hiccup/size 10)
             (hiccup/class "margin-left-1"))]
        (when (:watch-tutorial? @state)
          [:div [:iframe.margin-v-2 {:src "https://www.youtube.com/embed/yXYB-xrbiv0"}]])]
       [tc/a {:class "text-blue block margin-v-1"
              :href "https://www.homeserve.com/en-us/app/help/"
              :target "_blank"
              :rel "noopener"}
        (str (i/get :i/nameplate)
             " "
             (i/get :i/faq))]]]]))

